"use client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useTranslations } from "next-intl";
import Image from "next/image";
import Link from "next/link";
import { useRouter, useSearchParams } from "next/navigation";
import nProgress from "nprogress";
import { useEffect, useState } from "react";
import ui from "../../ui.json";
function SearchInput({ value }: { value: string }) {
  const t = useTranslations();
  const serachParams = useSearchParams();
  const serachQ = serachParams.get("q") || "";
  const router = useRouter();
  const [searchValue, setSearchValue] = useState(value);
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  };
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      nProgress.start();
      router.push(`/search?q=${encodeURIComponent(searchValue)}`);
    }
  };
  useEffect(() => {
    setSearchValue(serachQ);
  }, [serachQ]);

  return (
    <div className="!mt-0 flex w-full items-center space-x-2 relative mb-5">
      <Input
        type="text"
        onChange={handleInputChange}
        onKeyPress={handleKeyPress}
        value={searchValue as string}
        placeholder={t("search.searchBoxText")}
        className="pl-12 py-2.5 bg-grey-100 text-body-3 text-p-black border-none "
      />
      <Image
        src="./assets/input-icon-search.svg"
        alt={t("search.searchBoxText")}
        width="20"
        height="20"
        className="absolute left-2 top-2.5"
      />
      <Link
        href={
          searchValue?.length > 0
            ? `/search?q=${encodeURIComponent(searchValue)}`
            : `/search`
        }
        rel="preload"
        className="bg-black rounded-md p-2 flex item-center justify-center min-w-10"
        style={{
          backgroundColor: ui?.main_color,
        }}
      >
        <Image
          src="./assets/button-icon-search.svg"
          width="24"
          height="24"
          alt={t("search.searchBoxText")}
        />
      </Link>
    </div>
  );
}

export default SearchInput;
